<div class="fs-2 with-close" mat-dialog-title>
    Partagez votre simulation
    <i class="fa fa-close" (click)="onClose()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p class="text-center">
        <share-buttons [autoSetMeta]="false" [url]="'https://www.lybox.fr/app/annonces/share/' + publicId"></share-buttons><br/>
        ou copier le lien suivant : <br/>
        <a href="https://www.lybox.fr/app/annonces/share/{{ publicId }}">
            https://www.lybox.fr/app/annonces/share/{{ publicId }}
        </a>
    </p>
</div>

